
import Vue from "vue";
import { T, PopUps } from "../App.vue";

export default Vue.extend({
  name: "InfoScreen",
  props: {
    PopUp: Number,
  },
  data() {
    return {
      PopUps,
      gamePieces: ["seawall", "redesign", "relocate"],
    };
  },
  methods: {
    T(key: string): string {
      return T(key);
    },
  },
});
